<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
          <div class=" inpBox">
               <el-form-item label="队长名称:" prop="legalPerson">
                <el-input  placeholder="" maxlength="100" v-model="searchFrom.legalPerson"></el-input>
              </el-form-item>
              <el-form-item label="审核状态:" prop="auditStatus">
                <el-select v-model="searchFrom.auditStatus" placeholder="请选择">
                    <el-option label="全部" value=''></el-option>
                   <el-option label="待审核" :value=1></el-option>
                   <el-option label="审核通过"  :value=2></el-option>
                  <el-option label="审核未通过"  :value=3></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="申请时间:" prop="createTimes" >
                <el-date-picker
                  v-model="searchFrom.createTimes"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
              <div style="margin:10px 0 0 60px;">
              <el-form-item >
                <el-button type="primary"  @click="searchFn" >查询</el-button>
              </el-form-item>
              <el-form-item >
                <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
              </el-form-item>
              </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       style="width: 100%" height="100%"  center border>
           <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="province"    label="操作" align="center" width="180">
          <template slot-scope="scope">
            <!-- 1显示通过/驳回 ，不是1显示记录 -->
            <div>
            <el-button type="text" size="small" @click="passClick(scope.row)" btnCode="000P00XB003" v-if="scope.row.auditStatus == '1'">审核</el-button>
            <el-button type="text" size="small" @click="recordClick(scope.row)" btnCode="000P00XB006" v-if="scope.row.auditStatus!= '1'">记录</el-button>
            <!-- <el-button type="text" size="small" @click="rejectClick(scope.row)" btnCode="000P00XB005" v-if="scope.row.zzauditStatus == '1' ">驳回</el-button> -->
            <!-- <el-button type="text" size="small" @click="jiazhengFn(scope.row)" btnCode="000P00XB005" >驾证声明</el-button> -->
            </div>
          </template>
        </el-table-column>
       <el-table-column property="auditStatus" label="审核状态" >
          <template scope="scope">
            {{["待审核", "审核通过", "审核未通过" ][scope.row.auditStatus-1]}}
          </template>
        </el-table-column>
        <el-table-column prop="legalPerson"    label="队长名称"  align="center"  show-overflow-tooltip></el-table-column>
        <el-table-column prop="legalIdentityCard"  label="身份证号" align="center"  show-overflow-tooltip></el-table-column>
        <el-table-column property="userSex" label="性别" >
          <template scope="scope">
            {{["男", "女" ][scope.row.userSex-1]}}
          </template>
        </el-table-column>
        <el-table-column prop="mobile"  label="联系电话" align="center" ></el-table-column>
        <!-- <el-table-column prop="lastauditUser"  label="审核人" align="center" width="120"></el-table-column> -->
        <el-table-column prop="createTime"  label="申请时间" align="center"  :formatter="dateTimeFormat"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!--点击记录-->
    <el-dialog title="记录"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="recordMark"
    width="550px"
    center>
      <span>
        <el-timeline>
          <el-timeline-item  v-for="(activity, index) in activities" :key="index" :color="activities.length-1 ? '#0bbd87' : ''">
            <p>审核时间：{{activity.createTime|dateFormat}}</p>
            <p>审核人：{{activity.createUserName}}</p>
            <p>审核操作：{{["待审核", "审核通过", "审核未通过" ][activity.auditStatus-1]}}</p>
            <p v-if="activity.auditResult">审核结果：{{activity.auditResult}}</p>
          </el-timeline-item>
        </el-timeline>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="recordMark = false"  size='mini'>取 消</el-button>
      </span>
    </el-dialog>
     <!-- 审核 -->
    <drawer :imgList="imgList"  v-if="drawerFlag"  @destroy="destroy">
      <span>
         <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline jiaoyan" label-width="110px" size="mini">
        <div class="inpBox">
            <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>基本信息</span>
              </h4>
            </div>
              <el-form-item label="队长名称:" prop="legalPerson">
                <el-input  placeholder=""  maxlength="11" v-model.trim="addFrom.legalPerson" :readonly="true"></el-input>
              </el-form-item>
              <el-form-item label="身份证号:" prop="legalIdentityCard">
                <el-input   maxlength="18" v-model.trim="addFrom.legalIdentityCard" :readonly="true"></el-input>
              </el-form-item>
              <el-form-item label="联系电话:" prop="mobile" >
                <el-input  placeholder="" maxlength="11" v-model="addFrom.mobile" :readonly="true"></el-input>
              </el-form-item>
            <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>审核意见</span>
              </h4>
            </div>
            <div style="text-align: center;margin-bottom:20px">
               <el-input type="textarea" style="width: 95%;" v-model="addFrom.auditResult" onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"></el-input>
            </div>
             <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>运力信息</span>
              </h4>
            </div>
              <el-table :data="carList"  ref="table"   bordersize="mini"  height="400" style="width: 100%" center border>
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column fixed type="index" width="55" label="序号"></el-table-column>
              <el-table-column prop="vhcNo"  width="100" :formatter="emptyFn" label="车牌号"></el-table-column>
              <el-table-column prop="vhcTypeName"  width="150" :show-overflow-tooltip="true" :formatter="emptyFn" label="车辆类型"></el-table-column>
              <el-table-column property="vehicleTenantName" width="240"  :show-overflow-tooltip="true" :formatter="emptyFn" label="车辆所有人" > </el-table-column>
              <el-table-column prop="driverName"  width="150" :show-overflow-tooltip="true" :formatter="emptyFn" label="实际承运人"></el-table-column>
              <el-table-column prop="mobile" width="150" :formatter="emptyFn" label="联系方式"></el-table-column>
              <el-table-column prop="identityNo" width="200" :formatter="emptyFn"  label="身份证号"></el-table-column>
              <el-table-column prop="licenseNum" width="200" :show-overflow-tooltip="true" :formatter="emptyFn" label="驾驶证号"></el-table-column>
            </el-table>
        </div>
        </el-form>
      </span>
      <div class="footerBox">
        <el-button type="primary" @click="SHsaveFn(2)">通过</el-button>
        <el-button type="primary" @click="SHsaveFn(3)">驳回</el-button>
      </div>
    </drawer>
 </div>
</template>

<script>
import {
  sCompanyCaptainAuditList, // 列表查询
  tAuditHistoryAddAudit, // 驳回/通过
  tAuditHistoryList // 记录
} from '@/api/newCrm'
import { transportCapacityList } from '@/api/vgs-driver2.0'
import DonMessage from '@/utils/message'
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat } from '@/utils/util'
import { fileDownAll } from '@/utils/fileDownAll.js'
import drawer from '@/views/consignment/registerAttestation/drawer.vue'
export default {
  components: {
    drawer
  },
  data () {
    return {
      h: 500,
      dateTimeFormat: dateTimeFormat,
      emptyFn: emptyFn,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        auditStatus: 1
      },
      total: 0,
      loading: 'false',
      zzauditStatusOptions: [], // 审核状态
      // 记录
      activities: [],
      recordMark: false,
      drawerFlag: false,
      addFrom: {},
      carList: [],
      imgList: [],
      rules: {
        legalPerson: [
          { required: true, message: '请输入车队长', trigger: 'blur' }
        ],
        legalIdentityCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { validator: this.rule.idCardValidity, trigger: 'blur' }
        ],
        contractName: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        contractPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ]

      },
      btnFlg: [],
      btnIdArr: ['000P00XB001', '000P00XB002', '000P00XB003',
        '000P00XB005', '000P00XB006']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/registerAttestation/driverCheck')
    this.getList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    // 审核
    passClick (row) {
      transportCapacityList({ driverId: row.id, userIdentityNo: row.legalPersonId }).then(res => {
        this.carList = res
        this.addFrom = { ...row }
        this.drawerFlag = true
      }).catch(res => {
        console.log(res, (res))
      })
      this.imgList = []
      if (row.legalPersonpic1 != '') {
        this.imgList.push({ ImgUrl: row.legalPersonpic1Url, name: '身份证正页' })
      }
      if (row.legalPersonpic2 != '') {
        this.imgList.push({ ImgUrl: row.legalPersonpic2Url, name: '身份证副页' })
      }
      // if (row.transPermitpic1 != '') {
      //   this.imgList.push({ ImgUrl: row.transPermitpic1, name: '驾驶证正页' })
      // }
      // if (row.transPermitpic2 != '') {
      //   this.imgList.push({ ImgUrl: row.transPermitpic2, name: '驾驶证副页' })
      // }
    },
    destroy () {
      this.drawerFlag = false
    },
    SHsaveFn (n) {
      if (n == 3) {
        if (this.addFrom.auditResult) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          tAuditHistoryAddAudit({
            // 驳回传3  通过传2
            auditResult: this.addFrom.auditResult,
            infoId: this.addFrom.userId,
            infoType: 1,
            auditStatus: 3
          }).then(res => {
            loading.close()
            this.$message({
              message: '成功',
              type: 'success'
            })
            this.drawerFlag = false
            this.getList()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          this.$alert('请输入驳回原因', '系统提示')
        }
      } else {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        this.addFrom.auditStatus = 2
        this.addFrom.infoType = 1
        this.addFrom.infoId = this.addFrom.userId
        tAuditHistoryAddAudit({
          auditResult: this.addFrom.auditResult,
          infoId: this.addFrom.userId,
          infoType: 1,
          auditStatus: 2
        }).then(res => {
          loading.close()
          this.$message({
            message: '成功',
            type: 'success'
          })
          this.drawerFlag = false
          this.getList()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
        // this.$refs.addFrom.validate((valid) => {
        //   if (valid) {

        //   }
        // })
      }
    },
    // 驾证声明
    jiazhengFn (row) {
      fileDownAll(
        this.global.driverNameT + '/cDriverVehicleRel/exportCaptainModel',
        { userId: row.userId, userMoblie: row.mobile, userName: row.legalPerson, userIdentityNo: row.legalIdentityCard },
        row.legalPerson + '-驾证声明',
        '.doc'
      )
    },
    // 点击记录
    recordClick (row) {
      this.title = '记录'
      this.recordMark = true
      tAuditHistoryList({
        infoId: row.userId,
        infoType: 1
      }).then(res => {
        this.activities = res
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 获取列表
    getList () {
      this.loading = true
      this.loading = true
      sCompanyCaptainAuditList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
        this.$previewRefresh()
      }).catch(err => {
        this.loading = false
        DonMessage.error(err.message)
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.getList()
    },

    closeDialog () {
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
}

</style>
